<template>
    <div class="userRoom">
        <h1>个人中心</h1>
        <h4>用户名:{{userInfo.username}}</h4>
        <h4>昵称:{{userInfo.nickName}}</h4>
        <h4>角色:{{userInfo.roles}}</h4>
        <h4>手机号:{{userInfo.phone}}</h4>
        <h4>邮箱:{{userInfo.email}}</h4>
        <h4>个性签名:{{userInfo.sign}}</h4>
        <div>
            <el-button type="primary" round @click="updateUserInfo">
                修改个人信息
            </el-button>
        </div>

        <!-- 添加或修改用户对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body :before-close="cancel" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="用户名" prop="username">
                    <el-input disabled v-model="form.username" placeholder="请输入用户名" />
                </el-form-item>
                <el-form-item label="用户昵称" prop="nickName">
                    <el-input v-model="form.nickName" placeholder="请输入用户昵称" />
                </el-form-item>
                <el-form-item label="角色" prop="roles">
                    <el-input disabled v-model="form.roles" placeholder="请输入角色" />
                </el-form-item>
                <el-form-item label="头像地址" prop="avatar">
                    <el-input v-model="form.avatar" placeholder="请输入头像地址" />
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入手机号" />
                </el-form-item>
                <el-form-item label="邮箱地址" prop="email">
                    <el-input v-model="form.email" placeholder="请输入邮箱地址" />
                </el-form-item>
                <el-form-item label="签名" prop="sign">
                    <el-input v-model="form.sign" type="textarea" placeholder="请输入内容" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getUserInfo,updateUserInfo } from '@/api/user'

    export default {
        name: "userRoom",
        data() {
            var phoneCheck = (rule, value, callbackFn) => {
                const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
                if (value === "") {
                    callbackFn()
                }
                if (!reg.test(value)) {
                    callbackFn('请输入正确的手机号码')
                    return
                }
                callbackFn()
            };
            return {
                title:"",
                open:false,
                userInfo: {
                    id: "",
                    username: "",
                    nickName: "",
                    roles: "",
                    avatar: "",
                    phone: "",
                    email: "",
                },
                // 表单参数
                form: {

                },
                rules: {
                    username: [
                        // { required: true, message: '请输入活动名称', trigger: "" },
                        // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                    nickName: [
                        { required: true, message: '请输入昵称', trigger: 'change' },
                        { min: 1, max: 20, message: '昵称的长度不得超过20个字符', trigger: 'blur' }
                    ],
                    phone: [
                        { type: 'date', required: false, validator: phoneCheck, message: '请输入手机号码', trigger: 'blur' },
                    ],
                    email: [
                        { message: '请输入邮箱地址', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                    ],
                    sign: [
                        { message: '请输入您的个性签名', trigger: 'blur' },
                        { max: 200, message: '个性签名内容不得超过200个字符', trigger: 'blur' }
                    ],
                },
            }
        },
        created(){
            this.getUserInfo();
        },
        methods: {
            /*根据token获取用户信息*/
            getUserInfo(){
                this.$store
                    .dispatch("getUserInfo")
                    .then(response => {
                        if (response.code==200){
                            this.userInfo = response.data
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'error'
                            });
                            this.loading = false;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            showClose: true,
                            message: error.msg,
                            type: 'error'
                        });
                        this.loading = false;
                    });
            },

            /*更新用户信息*/
            updateUserInfo(){
                /** 修改按钮操作 */
                const token = this.$store.state.user.token;
                getUserInfo(token).then(response => {
                    this.form = response.data;
                    // this.form.id = response.data.id;
                    this.open = true;
                    this.title = "修改个人信息";
                });
            },

            /** 提交按钮 */
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        // console.log(this.form.id)
                        // console.log(this.form.userId)
                        if (this.form.id != null) {
                            updateUserInfo(this.form).then(response => {
                                if (response.code === 200) {
                                    this.open = false;
                                    // this.cancel();
                                    this.$message({ showClose: true, message: "修改成功", type: "success" });
                                    location.reload();
                                }
                            });
                        }
                    }
                });
            },

            /*取消按钮*/
            cancel() {
                this.open = false;
                // this.reset();
            },

            // /*表单重置*/
            // reset() {
            //     this.form = {
            //         id: null,
            //         username: null,
            //         nickName: null,
            //         avatar: null,
            //         phone: null,
            //         email: null,
            //         sign: null,
            //     };
            //     // this.resetForm("form");
            // },
        },
    }
</script>

<style scoped>
    .userRoom{
        width: 60%;
        margin: 0 auto;
    }
</style>
